import { SET_CUSTOM_FIELD_8 } from 'actions';

export function setCustomField8(sourceType: string) {
  return { sourceType, type: SET_CUSTOM_FIELD_8 };
}
